import { useState, useEffect } from 'react';
import { Input } from '~/components/common/forms';
import { useTranslate } from '~/i18n';
import useDebounce from '~/utils/useDebounce';
import { SearchIcon } from '~/svgs';

const SearchFilter = ({ onSearch }: any) => {
   const { translate } = useTranslate();
   const [searchValue, setSearchValue] = useState('');

   const debouncedValue = useDebounce(searchValue, 500);
   useEffect(() => {
      onSearch(debouncedValue);
   }, [debouncedValue, onSearch]);
   return (
      <div>
         <Input
            onChange={e => setSearchValue(e.currentTarget.value)}
            className="ltr:!border-l-0 rtl:!border-r-0 rtl:!border-l"
            inputWrapperClassName="[&>*]:hover:border-primary"
            groupClassName="!mb-0"
            placeholder={translate({ id: 'common:search' })}
            id="name_ar"
            maxLength={15}
            prepend={<SearchIcon className="w-8 " />}
         />
      </div>
   );
};

export default SearchFilter;
